<template>
  <CCard>
    <CCardHeader>
      <div class="card-title">{{ $t("user.profile.data.title") }}</div>
    </CCardHeader>
    <CCardBody>
      <div class="bd-example">
        <dl class="row">
          <dd class="col-sm-2">
            {{ $t("models.user.name") }}
          </dd>
          <dt class="col-sm-4">
            <CInput
              :description="$t('models.user.name_info')"
              horizontal
              autocomplete="name"
              v-model="dataForm.body.first_name"
              :is-valid="'first_name' in dataForm.errors ? false : null"
              :invalid-feedback="
                'first_name' in dataForm.errors
                  ? dataForm.errors.first_name.join('<br>')
                  : null
              "
            />
          </dt>
          <dd class="col-sm-2">
            {{ $t("models.user.surnname") }}
          </dd>
          <dt class="col-sm-4">
            <CInput
              :description="$t('models.user.surnname_info')"
              horizontal
              autocomplete="last_name"
              v-model="dataForm.body.last_name"
              :is-valid="'last_name' in dataForm.errors ? false : null"
              :invalid-feedback="
                'last_name' in dataForm.errors
                  ? dataForm.errors.last_name.join('<br>')
                  : null
              "
            />
          </dt>

          <dd class="col-sm-2">
            {{ $t("models.user.born") }}
          </dd>
          <dt class="col-sm-4">
            <CInput
              :description="$t('models.user.born_info')"
              horizontal
              autocomplete="born"
              type="date"
              v-model="dataForm.body.born"
              :is-valid="'born' in dataForm.errors ? false : null"
              :invalid-feedback="
                'born' in dataForm.errors
                  ? dataForm.errors.born.join('<br>')
                  : null
              "
            />
          </dt>

          <dd class="col-sm-2">
            {{ $t("models.user.phone") }}
          </dd>
          <dt class="col-sm-4">
            <CInput
              :description="$t('models.user.phone_info')"
              horizontal
              autocomplete="phone"
              v-model="dataForm.body.phone"
              :is-valid="'phone' in dataForm.errors ? false : null"
              :invalid-feedback="
                'phone' in dataForm.errors
                  ? dataForm.errors.phone.join('<br>')
                  : null
              "
            />
          </dt>

          <dd class="col-sm-2">
            {{ $t("models.user.lang") }}
          </dd>
          <dt class="col-sm-4">
            <CSelect
              :description="$t('user.profile.data.lang_info')"
              horizontal
              :is-valid="'language' in dataForm.errors ? false : null"
              :invalid-feedback="
                'language' in dataForm.errors
                  ? dataForm.errors.language.join('<br>')
                  : null
              "
              :value.sync="dataForm.body.language"
              :options="options"
            />
          </dt>

          <dd class="col-sm-2">
            {{ $t("models.user.defaultmail") }}
          </dd>
          <dt class="col-sm-4">{{ user.email }}</dt>

          <dd class="col-sm-2">
            {{ $t("models.user.dateregistered") }}
          </dd>
          <dt class="col-sm-4">
            {{ $d(new Date(user.date_joined), "long") }}
          </dt>
        </dl>
      </div>
    </CCardBody>
    <CCardFooter class="d-flex flex-row justify-content-start">
      <CButton color="primary" @click="SaveData()">
        {{ $t("common.editor.button.save") }}
      </CButton>
      <ProfileDataChangePassword />
    </CCardFooter>
  </CCard>
</template>

<script>
import ProfileDataChangePassword from "./ProfileDataChangePassword.vue";
import { apiPatch } from "../../helpers/apiHelper";

export default {
  name: "ProfileData",
  components: {
    ProfileDataChangePassword,
  },
  data() {
    return {
      dataForm: {
        loading: false,
        body: {
          first_name: "",
          last_name: "",
          nickname: "",
          born: "",
          phone: "",
          language: "",
        },
        errors: {},
      },
      languages: {
        de: "Deutsch",
        en: "English",
        it: "Italiano",
        fr: "Français",
      },
    };
  },
  mounted() {
    this.dataForm.body.first_name = this.user.first_name;
    this.dataForm.body.last_name = this.user.last_name;
    this.dataForm.body.nickname = this.user.nickname;
    this.dataForm.body.born = this.user.born;
    this.dataForm.body.phone = this.user.phone;
    this.dataForm.body.language = this.user.language;
  },
  computed: {
    user() {
      return this.$auth.user();
    },
    options() {
      let options = [];
      const langKeys = Object.keys(this.$i18n.messages);
      langKeys.forEach((key) => {
        options.push({
          value: key,
          label: this.languages[key],
        });
      });
      return options;
    },
  },
  methods: {
    async SaveData() {
      this.dataForm.loading = true;
      this.dataForm.errors = {};
      const response = await apiPatch("account_user", "", this.dataForm.body);
      if (response && response.status === 200) {
        this.$auth.user(response.data);
        this.dataForm.loading = false;
        this.$store.dispatch("toaster/add", {
          title: this.$t("user.profile.data.ok.title"),
          text: this.$t("user.profile.data.ok.message"),
          color: "success",
          autohide: true,
        });
      } else {
        console.error("Unexpected response:", response);
        this.dataForm.loading = false;
        this.dataForm.errors = response;
      }
    },
  },
};
</script>
